<template>
  <div class="app-container">
    <transition-group name="el-zoom-in-center">
      <!-- 项目头部列表 -->
      <div v-show="showList" key="header" class="filter-container">
        <el-card shadow="never" style="margin-bottom: 20px;">
          总收入：{{ TotalMoney }}（元）
        </el-card>
        <el-card class="custom-card" shadow="never">
          <el-input v-model="listQuery.userName" class="filter-item" placeholder="请输入用户名" style="width:200px;"/>
          <div class="filter-item">
            <el-date-picker
              v-model="listQuery.time"
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
          </div>

          <el-button
            v-waves
            round
            class="filter-item"
            type="primary"
            icon="el-icon-search"
            @click="handleFilter"
          >{{ $t('table.search') }}</el-button>
          <template v-if="list.length !== 0">
            <el-select
              v-model="bookType"
              :placeholder="$t('table.saveType')"
              clearable
              class="filter-item"
              style="width: 130px"
            >
              <el-option v-for="item in bookTypeList" :key="item" :label="item" :value="item"/>
            </el-select>
            <el-button
              v-waves
              :loading="downloadLoading"
              round
              class="filter-item"
              type="primary"
              icon="el-icon-download"
              @click="handleDownload"
            >{{ $t('table.export') }}</el-button>
          </template>
        </el-card>

      </div>
      <!-- 项目列表 -->
      <div v-show="showList" key="list" class="filter-container">
        <el-table
          v-loading="listLoading"
          :key="tableKey"
          :data="list"

          fit
          stripe
          highlight-current-row
          style="width: 100%;"
        >
          <el-table-column :label="$t('table.id')" align="center" width="50px">
            <template slot-scope="scope">
              <span>{{ (scope.$index + 1) + ((listQuery.pageIndex - 1) * listQuery.pageSize) }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="`用户名`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.UserName">{{ scope.row.UserName }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="`收益（元）`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.Amount" style="color: #3a8ee6; cursor: pointer;" @click="handleProfitDetail(scope.row.UserId)">{{ scope.row.Amount }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>
          <el-table-column :label="`场地数量`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.FieldCount">{{ scope.row.FieldCount }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>
        </el-table>
        <el-card class="custom-card" shadow="never">
          <el-pagination
            v-show="total>0"
            :current-page="listQuery.pageIndex"
            :page-sizes="[10,20,50,100]"
            :page-size="listQuery.pageSize"
            :total="total"
            layout="total, prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-card>
      </div>
    </transition-group>
    <el-dialog :visible.sync="dialogTableVisible" title="收益详情">
      <el-row :gutter="10" style="margin-bottom: 20px;">
        <el-col :span="3.5">
          <el-date-picker
            v-model="profitSearchTime"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="handleTimeChange"/>
        </el-col>
        <el-col :span="1.5">
          <el-button type="primary" @click="profitSearch">搜索</el-button>
        </el-col>
        <template v-if="profitData.length>0">
          <el-select
            v-model="bookType"
            :placeholder="$t('table.saveType')"
            clearable
            class="filter-item"
            style="width: 130px"
          >
            <el-option v-for="item in bookTypeList" :key="item" :label="item" :value="item"/>
          </el-select>
          <el-button
            v-waves
            :loading="downloadLoading"
            class="filter-item"
            type="primary"
            icon="el-icon-download"
            @click="handleDownloadProfit"
          >{{ $t('table.export') }}</el-button>
        </template>
      </el-row>
      <el-table
        :data="profitData"
        fit
        style="width: 100%">
        <el-table-column
          label="设备名称"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.Name">{{ scope.row.Name }}</span>
            <span v-else>---</span>
          </template>
        </el-table-column>
        <el-table-column
          label="场地名称"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.FieldName">{{ scope.row.FieldName }}</span>
            <span v-else>---</span>
          </template>
        </el-table-column>
        <el-table-column
          label="本次总收入"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.Money">{{ scope.row.Money }}</span>
            <span v-else>---</span>
          </template>
        </el-table-column>
        <el-table-column
          label="本次分成"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.Profit">{{ scope.row.Profit }}</span>
            <span v-else>---</span>
          </template>
        </el-table-column>
        <el-table-column
          label="分成比例"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.Proportion">{{ scope.row.Proportion }}</span>
            <span v-else>---</span>
          </template>
        </el-table-column>
        <el-table-column
          label="订单创建时间"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.AddTime">{{ scope.row.AddTime }}</span>
            <span v-else>---</span>
          </template>
        </el-table-column>
        <el-table-column
          label="订单结束时间"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.EndTime">{{ scope.row.EndTime }}</span>
            <span v-else>---</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          v-show="profitTotal>0"
          :current-page="profitListQuery.pageIndex"
          :page-sizes="[10,20,50,100]"
          :page-size="profitListQuery.pageSize"
          :total="profitTotal"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleProfitDetailSizeChange"
          @current-change="handleProfitDetailCurrentChange"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { qryRoleInfo } from '@/api/baseModule'
import { qryFieldIncome, incomeDetail } from '@/api/report'
// import { parseTime } from '@/utils'
import waves from '@/directive/waves' // 水波纹指令
export default {
  directives: {
    waves
  },
  filters: {
    filterType(value) {
      let str = ''
      switch (value) {
        case 'profit':
          str = '收益'
          break
        case 'topUp':
          str = '充值'
          break
        case 'back':
          str = '返回'
          break
      }
      return str
    }
  },
  data() {
    return {
      listQuery: {
        pageIndex: 1,
        pageSize: 10,
        userName: null,
        time: null
      },
      profitListQuery: {
        pageIndex: 1,
        pageSize: 10,
        userId: null,
        startTime: null,
        endTime: null
      },
      profitData: [],
      profitSearchTime: [],
      list: [],
      showList: true,
      permition: 0,
      listLoading: true,
      tableKey: 0,
      total: null,
      bookType: 'xlsx',
      bookTypeList: ['xlsx', 'csv', 'txt'],
      downloadLoading: false,
      qr: null,
      TotalMoney: 0,
      dialogTableVisible: false,
      profitTotal: 0
    }
  },
  created() {
    if (this.$store.state.roleInfo) {
      this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
        if (this.$route.path === item.ProgramInfo.PgUrl) {
          this.permition = item.Permition
          this.qryList()
        }
      })
    } else {
      qryRoleInfo({
        rId: this.$store.getters.roles.RoleId
      }).then(response => {
        this.$store.state.roleInfo = response
        response.LsList[0].RolePrograms.forEach(item => {
          if (this.$route.path === item.ProgramInfo.PgUrl) {
            this.permition = item.Permition
            console.log('173', this.permition)
            this.qryList()
          }
        })
      })
    }
  },
  methods: {
    // 查询列表
    qryList() {
      qryFieldIncome(this.listQuery).then(response => {
        this.list = response.LsList.LsList
        this.TotalMoney = response.TotalMoney
        this.total = response.LsList.TotalRows
        this.listLoading = false
        // this.resetTemp()
      })
    },
    // 时间切换
    handleTimeChange() {
      if (this.profitSearchTime) {
        this.profitListQuery.startTime = this.profitSearchTime[0]
        this.profitListQuery.endTime = this.profitSearchTime[1]
      } else {
        this.profitListQuery.startTime = null
        this.profitListQuery.endTime = null
      }
    },
    handleProfitDetail(userId) {
      this.dialogTableVisible = true
      this.profitListQuery.userId = userId
      this.getProfitDetail()
    },
    // 获取收益详情
    getProfitDetail() {
      incomeDetail(this.profitListQuery).then(res => {
        this.profitData = res.LsList
        this.profitTotal = res.TotalRows
      })
    },
    // 详情搜索
    profitSearch() {
      this.getProfitDetail()
    },
    // 重置查询数据
    resetTemp() {
      this.listQuery = {
        pageIndex: this.listQuery.pageIndex,
        pageSize: this.listQuery.pageSize,
        userName: null,
        time: null
      }
    },
    // 数据导出
    handleDownload() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['用户名', '收益（元）', '设备数量']
        const filterVal = ['UserName', 'Amount', 'ImeiCount']
        const list = this.list
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '场地方收入统计',
          autoWidth: true,
          bookType: this.bookType
        })
        this.downloadLoading = false
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        // console.log(v)
        // console.log(j)
        return v[j]
      }))
    },
    // 数据导出
    handleDownloadProfit() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['设备名称', '场地名称', '本次总收入', '本次分成', '分成比例', '时间']
        const filterVal = ['Name', 'FieldName', 'Money', 'Profit', 'Proportion', 'Time']
        const list = this.profitData
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '场地方收入详情',
          autoWidth: true,
          bookType: this.bookType
        })
        this.downloadLoading = false
      })
    },
    // 修改页容量重新查询列表
    handleSizeChange(val) {
      this.listQuery.pageSize = val
      this.qryList()
    },
    // 修改页码重新查询列表
    handleCurrentChange(val) {
      this.listQuery.pageIndex = val
      this.qryList()
    },
    // 修改页容量重新查询列表
    handleProfitDetailSizeChange(val) {
      this.profitListQuery.pageSize = val
      this.getProfitDetail()
    },
    // 修改页码重新查询列表
    handleProfitDetailCurrentChange(val) {
      this.profitListQuery.pageIndex = val
      this.getProfitDetail()
    },
    handleFilter() {
      this.qryList()
    }
  }
}
</script>

<style lang="less">
</style>
